import { useQuery } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { FISCAL_YEAR_API } from "./apiRoutes";

const getOperationalLogs = async (communityId: string | number, fiscalYear: string | number) => {
  return await axiosAuth.get(`${FISCAL_YEAR_API(communityId)}/${fiscalYear}/operation-logs`);
};

const useGetOperationalLogs = ({communityId, fiscalYear}: {communityId?: string | number, fiscalYear?: string | number}) =>
  useQuery({
    queryKey: ["operational-logs", communityId, fiscalYear],
    queryFn: () => getOperationalLogs(communityId!, fiscalYear!),
    select: (data: any) => data.data,
    enabled: !!communityId && !!fiscalYear,
  });

export default useGetOperationalLogs;